import React, { useMemo } from "react";
import DocumentCard from "@components/DocumentCard/DocumentCard";
import type { ReviewFalProps } from "@features/vessel-call/vessel-call-status/VesselCallDetails/ImoFalReview/types";
import { getFal3ShipsStoresDeclarationData } from "@features/vessel-call/vessel-call-status/VesselCallDetails/utils";
import { useDownloadCertificate } from "@pages/vessel-management/vessel-status/hooks/useDownloadCertificate";
import { useTranslation } from "react-i18next";

const ReviewFal3: React.FC<ReviewFalProps> = ({ vesselCallDetails, vesselRegisterDetails }) => {
  const { t } = useTranslation();
  const { handleDownload, handlePreview } = useDownloadCertificate();
  const { shipsStoresUrl, fileName, translationTitle, testIds } = useMemo(
    () =>
      getFal3ShipsStoresDeclarationData({
        vesselCallDetails,
        vesselRegisterDetails,
        t,
      }),
    [vesselCallDetails, vesselRegisterDetails, t],
  );

  return (
    <div className="flex flex-col gap-4" data-testid={testIds.wrapper}>
      <h2 className="text-xl">{translationTitle}</h2>
      {shipsStoresUrl ? (
        <div className="grid grid-cols-2">
          <DocumentCard
            testId={testIds.card}
            title={""}
            fileName={fileName}
            onDownload={() =>
              handleDownload("certificate", "bff-vessel-call", shipsStoresUrl, fileName)
            }
            onPreview={() => handlePreview("certificate", "bff-vessel-call", shipsStoresUrl)}
          />
        </div>
      ) : (
        <div className="text-gray-500 font-normal text-sm" data-testid={testIds.empty}>
          {t("vessel-call.certificates.empty")}
        </div>
      )}
    </div>
  );
};

export default ReviewFal3;
